'use strict';

const {URL} = require('bunsen/helpers/uri');
const User = require('../../models/User');
const referrerHelpers = require('../../tracking/referrerHelpers');
const mobileAdsHelpers = require('../../mobileAds/helpers/mobileAdsHelpers');
const mobileAdsBase = require('../../mobileAds/mobileAdsBase');
const mobileAdsConstants = require('../../mobileAds/mobileAdsConstants');
const pageTypeHelper = require('../pageTypeHelper');
const {PAGE_TYPE} = require('../../constants/pageTypes');
const VisitCountModel = require('../../tracking/models/VisitCountModel');

const isAllowedPageType = function isAllowedPageType() {
    return !pageTypeHelper.isPageType(PAGE_TYPE.CHECKOUT);
};

const checkPageViewCount = function checkPageViewCount() {
    const visitCountModel = new VisitCountModel();
    return visitCountModel.get('session') >= 2;
};

const shouldSeeInterstitial = function shouldSeeInterstitial() {
    const emailToken = URL.queryKey.emailToken;
    let emailReferrer = sessionStorage.getItem('emailReferrer');

    if (referrerHelpers.isEmailReferrer() || emailToken) {
        sessionStorage.setItem('emailReferrer', true);
        emailReferrer = true;
    }

    return User.loggedIn() && mobileAdsHelpers.shouldShowAd() && !emailReferrer && isAllowedPageType() && !referrerHelpers.isAmpReferrer() && checkPageViewCount();
};

/**
 * Condition:
 * second page view,
 * logged in user,
 * no cookie "dibsMobileInterstitial",
 * not PlaReferrer, not email referrer,
 * not checkout
 * iphone
 *
 * @return {Promise}
 */
const mobileAdsRule = function loginPromptRule() {
    const {NOTIFICATION_TYPE} = mobileAdsConstants;

    if (shouldSeeInterstitial()) {
        mobileAdsBase.showAd();
        Promise.resolve({type: NOTIFICATION_TYPE});
    }

    return Promise.resolve();
};

module.exports = mobileAdsRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/mobileAdsRule.es.js